import Energy from "@hydrologiq/shared/monitoring/figures/Energy"
import { EnergyUnit } from "@hydrologiq/common/types/energy/consumption"
import { AssetHeadlineFigure } from "@hydrologiq/gql-experience/graphql"
import { isCompactFigure } from "@hydrologiq/shared/figures/generic/figureVariant"

interface HydrogenUsedFigureProps {
  data?: AssetHeadlineFigure
  loading?: boolean
  error?: string
  isPlaceholder?: boolean
  compact?: boolean
}

function HydrogenUsedFigure({ data, loading, error, isPlaceholder, compact = isCompactFigure("energy_flow") }: HydrogenUsedFigureProps) {
  const quantity = data?.value ?? 0
  const previousQuantity = data?.previousValue ?? 0

  // Map unit string to EnergyUnit enum
  const unitMap: Record<string, EnergyUnit> = {
    kg: EnergyUnit.kg,
    kwh: EnergyUnit.KWH,
    wh: EnergyUnit.WH,
  }
  const desiredUnit = unitMap[data?.unit?.toLowerCase() ?? "kg"] ?? EnergyUnit.kg

  // Determine period from metadata or default to latest
  const period = data?.metadata?.period ?? "today"

  return (
    <Energy
      quantity={quantity}
      desiredUnit={desiredUnit}
      period={period}
      previousQuantity={previousQuantity}
      heading={data?.label}
      loading={loading}
      error={error}
      isPlaceholder={isPlaceholder}
      compact={compact}
    />
  )
}

export default HydrogenUsedFigure
